<template>
	<v-slider v-bind="$attrs" v-on="$listeners" v-model="localValue" hide-details>
		<template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope"><slot :name="slot" v-bind="scope" /></template>
	</v-slider>
</template>

<script>
import VModelMixin from '@/mixins/VModelMixin';
import AtomsMixins from './common/atoms.mixin';
export default {
	name: 'AppSlider',
	mixins: [VModelMixin, AtomsMixins],
};
</script>

<style scoped lang="scss"></style>
